import {useMutation} from "@tanstack/react-query";

import {deleteSupplierMutationOptions} from "./delete-supplier.mutation-options";

export function useDeleteSupplier() {
  return useMutation(deleteSupplierMutationOptions());
}
